import React from 'react';
import Table from '../../components/ui/Table.jsx';
import { useApi } from '../../hooks/useApi.js';
import { Link } from '../../router.jsx';

export default function StaffEmails() {
  const [query, setQuery] = React.useState('');
  const [offset, setOffset] = React.useState(0);
  const limit = 25;
  const path = `/api/emails?limit=${limit}&offset=${offset}&q=${encodeURIComponent(query)}`;
  const { data, loading, error } = useApi(path, [query, offset]);
  const items = data?.items || [];
  const columns = [
    { key: 'date', label: 'Date' },
    { key: 'recipient', label: 'Recipient' },
    { key: 'subject', label: 'Subject' },
    { key: 'actions', label: 'Actions' }
  ];

  const tableData = items.map((email) => ({
    date: email.date,
    recipient: email.student_name || '—',
    subject: <Link to={`/staff/emails/${email.id}`}>{email.subject || '—'}</Link>,
    actions: <Link className="btn btn-ghost" to={`/staff/emails/${email.id}`}>View</Link>
  }));

  const filters = (
    <input
      className="input table-search"
      type="search"
      placeholder="Search by student or subject"
      value={query}
      onChange={(event) => {
        setQuery(event.target.value);
        setOffset(0);
      }}
    />
  );

  const pagination = {
    offset,
    limit,
    hasNext: items.length === limit,
    onPageChange: setOffset
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Email Communications</h1>
          <p className="subtle">Audit outbound notifications.</p>
        </div>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {loading ? (
        <p className="subtle">Loading...</p>
      ) : (
        <Table
          columns={columns}
          data={tableData}
          filters={filters}
          pagination={pagination}
          emptyMessage="No emails found."
        />
      )}
    </div>
  );
}
